export const QUOTE_STATUSES = [
  { id: "sent", label: "Sent", color: "hsl(var(--foreground))", bg: "hsl(var(--muted))" },
  { id: "in_progress", label: "In progress", color: "hsl(var(--status-halfday))", bg: "hsl(var(--status-halfday) / 0.14)" },
  { id: "won", label: "Won", color: "hsl(var(--status-present))", bg: "hsl(var(--status-present) / 0.14)" },
  { id: "lost", label: "Lost", color: "hsl(var(--status-absent))", bg: "hsl(var(--status-absent) / 0.14)" },
];

export const DISPATCH_STATUSES = [
  { id: "pending", label: "Pending", color: "hsl(var(--muted-foreground))" },
  { id: "packed", label: "Packed", color: "hsl(var(--status-halfday))" },
  { id: "ready_to_dispatch", label: "Ready to dispatch", color: "hsl(var(--status-leave))" },
  { id: "in_route", label: "In route", color: "hsl(var(--status-halfday))" },
  { id: "completed", label: "Completed", color: "hsl(var(--status-present))" },
];

export function statusMeta(id) {
  return QUOTE_STATUSES.find((s) => s.id === id) || QUOTE_STATUSES[0];
}
export function dispatchMeta(id) {
  return DISPATCH_STATUSES.find((s) => s.id === id) || DISPATCH_STATUSES[0];
}

export function formatMoney(n) {
  const v = Number(n || 0);
  const abs = Math.abs(v).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${v < 0 ? "-" : ""}₹${abs}`;
}

export function relativeTime(iso) {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  const now = Date.now();
  const s = Math.round((now - then) / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.round(h / 24);
  if (d < 30) return `${d}d ago`;
  return new Date(iso).toLocaleDateString();
}
